// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GatewaySourceTypeSchema = z.enum(['CNAME_PATTERN','CDN_CHECK','REVERSE_PTR','CLOUD_INVENTORY'] as const);

export type GatewaySourceTypeType = `${z.infer<typeof GatewaySourceTypeSchema>}`

export default GatewaySourceTypeSchema;
